export const downloadFile = (filename, content) => {
  // Handle client generation and save on IE10+
  if (navigator.msSaveBlob) {
    // Source: https://gist.github.com/aermolaev/a96ba40cd68fe357195f
    const dataURLToBlob = function (dataURL) {
      const BASE64_MARKER = ";base64,";
      if (dataURL.indexOf(BASE64_MARKER) == -1) {
        const parts = dataURL.split(",");
        const contentType = parts[0].split(":")[1];
        const raw = decodeURIComponent(parts[1]);

        return new Blob([raw], { type: contentType });
      }

      const parts = dataURL.split(BASE64_MARKER);
      const contentType = parts[0].split(":")[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;

      const uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      return new Blob([uInt8Array], { type: contentType });
    };

    const fileBlob = dataURLToBlob(content);
    navigator.msSaveBlob(fileBlob, filename);
    return;
  }

  // Handle saving on browsers other than IE10+
  var element = document.createElement("a");
  element.setAttribute("href", content);
  element.setAttribute("download", filename);

  // In order to prevent an error in Google Tag Manager's script, we need to stop propagating this event
  element.addEventListener("click", (e) => {
    e.stopPropagation();
  });

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

// Source: https://ourcodeworld.com/articles/read/189/how-to-create-a-file-and-generate-a-download-with-javascript-in-the-browser-without-a-server
export function downloadText(filename, text) {
  downloadFile(
    filename,
    "data:text/plain;charset=utf-8," + encodeURIComponent(text),
  );
}
